<template>
  <div class="footer">
    © 2018 Malabaristas
  </div>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style lang="scss" scoped>
@import "../assets/css/base.scss";

.footer {
  padding: 5px;
  background-color: $black;
  color: $white;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue